module.exports = "<div class=\"loader\">\n    <div class=\"loading\">\n        <div class=\"bounceball\"></div>\n        <div class=\"loader-message\">Connexion en cours</div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/account/fc-auth-redirect/fc-auth-redirect.component.html
// module id = 766
// module chunks = 0